import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCloud, FiShare2, FiLink, FiDownload, FiCheckCircle, FiExternalLink } = FiIcons;

const steps = [
  {
    id: 1,
    title: "Dropbox Account",
    description: "Create a free Dropbox Basic account, which gives you 2GB of cloud storage.",
    icon: FiCloud,
    link: "https://www.dropbox.com/",
    linkText: "Visit Dropbox"
  },
  {
    id: 2,
    title: "Upload APK",
    description: "Upload your APK file directly to your Dropbox storage.",
    icon: FiDownload,
  },
  {
    id: 3,
    title: "Share Link",
    description: "Tap the share button on your uploaded file to generate a public share link.",
    icon: FiShare2,
  },
  {
    id: 4,
    title: "Direct Link Conversion",
    description: "Visit the conversion tool to turn your share link into a direct download link (DDL).",
    icon: FiLink,
    link: "https://schrodingers-b0x.github.io/DropB0X-DDL/",
    linkText: "Link Converter"
  },
  {
    id: 5,
    title: "Follow Instructions",
    description: "Follow the on-screen instructions to generate a DDL specifically for app stores or Downloader short-codes.",
    icon: FiCheckCircle,
  },
  {
    id: 6,
    title: "Short Code Creation",
    description: "Go to AFTV News and paste your new DDL to create a convenient short code.",
    icon: FiExternalLink,
    link: "https://aftv.news/",
    linkText: "Create Short Code"
  }
];

const HostGuide = () => {
  return (
    <main className="pt-32 pb-24 px-6">
      <div className="max-w-4xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h1 className="text-3xl md:text-5xl font-black text-white mb-6 uppercase tracking-tight leading-tight">
            How to host your APK on <span className="text-yellow-500">Downloader</span> using Dropbox
          </h1>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            A simple, step-by-step guide to hosting your application files and creating easy-to-use short codes for your users.
          </p>
        </motion.div>

        <div className="space-y-6">
          {steps.map((step, index) => (
            <motion.div
              key={step.id}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-[#111113] border border-white/5 p-8 rounded-3xl flex flex-col md:flex-row gap-6 items-start hover:border-yellow-500/30 transition-colors"
            >
              <div className="w-12 h-12 rounded-2xl bg-yellow-500 flex items-center justify-center shrink-0 shadow-[0_0_20px_rgba(234,179,8,0.2)]">
                <SafeIcon icon={step.icon} className="text-black text-xl" />
              </div>
              
              <div className="flex-grow">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-yellow-500 font-black text-sm">STEP {step.id}</span>
                  <h3 className="text-xl font-bold text-white uppercase tracking-tight">{step.title}</h3>
                </div>
                <p className="text-slate-400 leading-relaxed mb-4">
                  {step.description}
                </p>
                {step.link && (
                  <a 
                    href={step.link} 
                    target="_blank" 
                    rel="noreferrer"
                    className="inline-flex items-center gap-2 text-yellow-500 font-bold hover:text-yellow-400 transition-colors group"
                  >
                    {step.linkText}
                    <SafeIcon icon={FiExternalLink} className="text-sm group-hover:translate-x-1 transition-transform" />
                  </a>
                )}
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
          className="mt-16 p-8 bg-yellow-500/5 border border-yellow-500/20 rounded-3xl text-center"
        >
          <p className="text-slate-300 font-medium">
            This method ensures your APK is hosted reliably and accessible via simple 5-6 digit codes for any device using the Downloader app.
          </p>
        </motion.div>
      </div>
    </main>
  );
};

export default HostGuide;